import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/base.scss'
import '@/plugins/Element'
import VueParticles from 'vue-particles'
import http from '@/server'
import { toFormData } from '@/utils/toolsForCommon'
import RoleCode from './utils/role'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './assets/font/iconfont.css'
import echarts from '@/plugins/Echarts'
import 'echarts-gl'
import Print from 'vue-print-nb'
import './assets/styles/animate.min.css'

Vue.use(Print)
Vue.prototype.$RoleCode = RoleCode
Vue.prototype.$toFormData = toFormData
Vue.use(VueParticles)
Vue.prototype.$http = http
Vue.config.productionTip = false

// 预览的地址：
const previewURLPRO = 'http://8.129.3.31:8012'
// const previewURLDEV = 'http://xiaokedamowang.cn:8012'
// const previewURLDEV = 'https://testeducation.gaxszz.cn:18112'
const previewURLDEV = 'http://testeducation.gaxszz.cn:18012'
Vue.prototype.$previewURL = previewURLPRO

// websocket地址：
// const websocketURLPRO = 'ws://8.129.3.31:8090'
// const websocketURLDEV = 'ws://xiaokedamowang.cn:8090'
// Vue.prototype.$websocketURL = websocketURLDEV

const organizationNameForWelcom: string = '公安县'
Vue.prototype.$organizationNameForWelcom = organizationNameForWelcom

const officialDocumentFileTitleForOrganation = '教育局'
Vue.prototype.$officialDocumentFileTitleForOrganation = officialDocumentFileTitleForOrganation

Vue.use(VueQuillEditor /* { default global options } */)
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
} as any)
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    // document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
